import api from '../api/axios';

let timer: number | null = null;

export function startHeartbeat(intervalMs = 180000) {
  stopHeartbeat();
  timer = window.setInterval(async () => {
    const token = localStorage.getItem('token');
    if (!token) return; // not logged in
    try {
      await api.post('/session/heartbeat');
    } catch (e) {
      // If heartbeat fails (401/403), axios interceptor will redirect
    }
  }, intervalMs);
}

export function stopHeartbeat() {
  if (timer) {
    window.clearInterval(timer);
    timer = null;
  }
}